import { Link } from 'react-router-dom';
import image from "../../assets/img/page/image-1.png";
import bgImage from "../../assets/img/portfolio/portfolio-8.jpg";

const AboutMain = () => {
    const whyChooseUs = [
        "Experienced Civil Engineering Team",
        "Government Tender Expertise",
        "End-to-End Solutions",
        "Timely Delivery",
        "Transparent Process"
    ];

    const divisions = [
        { name: "Arclight Infra Projects", desc: "Government tenders, roads, drainage, bridges, lake & water body development." },
        { name: "Arclight Developers", desc: "Residential schemes, plotting, township projects." },
        { name: "Arclight Constructions", desc: "House, shops, office construction." },
        { name: "Arclight Infrastructure (Private)", desc: "Roads, pipelines, site development." },
        { name: "Arclight Industrial Construction", desc: "Warehouses, factories, sheds." },
        { name: "Arclight BuildTech", desc: "RCC, paver blocks, modern construction." },
        { name: "Arclight Realty", desc: "Property dealing, investment consultancy." },
        { name: "Arclight Engineering Services", desc: "Architectural & structural AutoCAD, 2D/3D, VR, BOQ." },
        { name: "Arclight Civil Consultancy", desc: "PMC, Third party inspection, tender consultancy." },
        { name: "Arclight ADPF", desc: "Online permissions, NA/NOC." },
        { name: "Arclight CSC Work", desc: "Govt online services, documentation." }
    ];

    return (
        <>
            {/* Vision & Mission Section */}
            <div className="mission__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 lg-mb-25">
                            <div className="mission__area-left mr-40 xl-mr-0">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Vision & Mission</span>
                                <h2 className="title_split_anim">Building Stronger Communities and Facilities</h2>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="mission__area-right">
                                <div className="row">
                                    <div className="col-md-6 md-mb-25 wow fadeInUp" data-wow-delay=".6s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-target"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Our Vision</h4>
                                                <p>To become a trusted name in civil and infrastructure development by delivering quality work that contributes to stronger communities and better public facilities.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 wow fadeInUp" data-wow-delay=".9s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-medal"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Our Mission</h4>
                                                <p>To execute every project with professionalism, durability, timely delivery, and attention to engineering standards.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Arclight Developers Section */}
            <div className="about__five section-padding pt-0">
                <div className="container">
                    <div className="row al-center">
                        <div className="col-lg-5 lg-mb-25">
                            <div className="about__five-image wow img_left_animation">
                                <img src={image} alt="image" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about__five-right ml-70 xl-ml-0">
                                <div className="about__five-right-title">
                                    <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">About Arclight Developers</span>
                                    <h2 className="title_split_anim">Dedicated to Infrastructure and Civil Development</h2>
                                </div>
                                
                                <p className="wow fadeInUp mt-20 mb-30" data-wow-delay=".5s" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                    <strong>Arclight Developer</strong> is a multi-disciplinary civil engineering company providing complete solutions ranging from government infrastructure projects to private construction, real estate development, and consultancy services. Our focus is on quality, transparency, and timely delivery. 
                                </p>

                                <div className="features wow fadeInUp mt-40" data-wow-delay=".6s" style={{
                                    backgroundImage: `url(${bgImage})`, 
                                    padding: '40px 30px', 
                                    borderRadius: '10px', 
                                    position: 'relative', 
                                    zIndex: 1,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}>
                                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(10, 10, 10, 0.75)', borderRadius: '10px', zIndex: -1 }}></div>
                                    <h4 style={{color: '#fff', marginBottom: '15px'}}>Founder: Aakash Vaghela</h4>
                                    <p style={{color: '#eaeaea', margin: 0, lineHeight: '1.6'}}>Under the guidance of Aakash Vaghela, Arclight Developers works with a clear commitment toward dependable project execution, disciplined work processes, and result-oriented infrastructure solutions.</p>
                                </div>

                                <div className="row mt-40 wow fadeInUp" data-wow-delay=".8s">
                                    <div className="col-12">
                                        <h4 className="mb-20">Why Choose Us</h4>
                                        <ul style={{ listStyleType: 'none', padding: 0, display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                                            {whyChooseUs.map((value, index) => (
                                                <li key={index} style={{ width: 'calc(50% - 15px)', fontSize: '16px', fontWeight: '500', display: 'flex', alignItems: 'center' }}>
                                                    <i className="fas fa-check-circle" style={{ color: '#ff5e14', marginRight: '10px' }}></i>
                                                    {value}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                {/* <div className="item_bounce mt-40">
                                    <Link className="build_button" to="/portfolio/3-columns">See Projects<i className="flaticon-right-up"></i></Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Our Divisions Section (New) */}
            <div className="divisions__area section-padding pt-0" style={{ backgroundColor: '#f9f9f9', padding: '80px 0' }}>
                <div className="container">
                    <div className="row mb-50">
                        <div className="col-12 text-center">
                            <span className="subtitle wow fadeInUp" data-wow-delay=".2s">Our Expertise</span>
                            <h2 className="wow fadeInUp" data-wow-delay=".4s">Our Divisions</h2>
                            <p className="mt-15 wow fadeInUp" data-wow-delay=".6s" style={{ maxWidth: '700px', margin: '0 auto' }}>
                                We operate across multiple specialized divisions to provide comprehensive, end-to-end solutions for all your construction and development needs.
                            </p>
                        </div>
                    </div>
                    
                    <div className="row">
                        {divisions.map((division, index) => (
                            <div key={index} className="col-lg-4 col-md-6 mb-30 wow fadeInUp" data-wow-delay={`${0.2 + (index * 0.1)}s`}>
                                <div className="division-card" style={{ 
                                    padding: '30px', 
                                    backgroundColor: '#fff', 
                                    borderRadius: '8px', 
                                    boxShadow: '0 5px 20px rgba(0,0,0,0.05)', 
                                    height: '100%',
                                    borderBottom: '3px solid #ff5e14',
                                    transition: 'transform 0.3s ease'
                                }}>
                                    <h4 style={{ fontSize: '20px', marginBottom: '15px' }}>
                                        <span style={{ color: '#ff5e14', marginRight: '8px' }}>{index + 1}.</span> 
                                        {division.name}
                                    </h4>
                                    <p style={{ margin: 0, color: '#666', lineHeight: '1.6' }}>
                                        {division.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutMain;